function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "Sorry, something went wrong"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "We've encountered an issue. Please reload or try again later."
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "Reload"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "Return to Homepage"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import React from "react";
import { t } from "ttag";
import { Button } from "antd";
import useTranslation from "../../hooks/useTranslation";
import Layout from "./Layout";
var HTTP500 = function(param) {
    var _param_scoped = param.scoped, scoped = _param_scoped === void 0 ? false : _param_scoped, _param_previousHref = param.previousHref, previousHref = _param_previousHref === void 0 ? "/" : _param_previousHref, _param_customButton = param.customButton, customButton = _param_customButton === void 0 ? null : _param_customButton;
    useTranslation();
    return /*#__PURE__*/ React.createElement(Layout, {
        scoped: scoped,
        title: t(_templateObject()),
        body: t(_templateObject1()),
        support: false
    }, /*#__PURE__*/ React.createElement(Button, {
        type: scoped ? "default" : "primary",
        onClick: function() {
            return window.location.reload();
        }
    }, t(_templateObject2())), !scoped && /*#__PURE__*/ React.createElement(Button, {
        type: "default",
        onClick: function() {
            return window.location.replace(previousHref);
        }
    }, t(_templateObject3())), customButton && /*#__PURE__*/ React.createElement(Button, {
        type: "default",
        onClick: customButton.onClick
    }, customButton.text));
};
export default HTTP500;
